import { SchoolApi } from 'api/schoolApi';
import { ICountry, ISchool, SchoolParser } from 'pages/manageSchool/models';
import { useCallback, useEffect } from 'react';

export const useFetchSchoolDetails = (
  setSchoolDetails: React.Dispatch<React.SetStateAction<ISchool | null>>
) => {
  const fetchUserDetails = useCallback(async () => {
    const result = await SchoolApi.getSchoolDetails();
    if (result.data) {
      let data = result.data;

      let countryData: ICountry[] = [];
      const countryListResult = await SchoolApi.getCountriesList();
      const countryListData = countryListResult.data.details;

      if (data) {
        countryData = countryListData.countries.map((item: ICountry) =>
          SchoolParser.parseCountryList(item)
        );
      }
      data.countryList = countryData;

      if(data.countriesId){
        let selectedCountry = countryData.filter((country: any) => country.value === data.countriesId);
        data.selectedCountry = selectedCountry.length > 0 ? selectedCountry[0] : null;
      }

      setSchoolDetails(data);
    }

    if (result.error) {
      const error = result.error.message;
    }
  }, []);

  useEffect(() => {
    fetchUserDetails();
  }, []);
};

export default useFetchSchoolDetails;
